<template>
    <footer class="pds-footer">
        <div class="pds-footer__content">
            <div class="pds-footer__logo">
                <LogoSvg />
            </div>
            <div class="pds-footer__links">
                <a
                    :href="`${termsUrl}#TERMS`"
                    target="_blank"
                    class="pds-footer__link pds-typo-caption-md-bold"
                >
                    이용약관
                </a>
                <span class="pds-footer__separator" />
                <a
                    :href="`${termsUrl}#PRIVACY_POLICY`"
                    target="_blank"
                    class="pds-footer__link pds-footer__link--strong pds-typo-caption-md-bold"
                >
                    개인정보처리방침
                </a>
            </div>
            <div class="pds-footer__info">
                <p class="pds-footer__info-row pds-typo-caption-md-medium">
                    <span
                        class="pds-footer__info-label pds-typo-caption-md-bold"
                    >
                        여기어때 고객행복센터
                    </span>
                    <span>1670-6250</span>
                </p>
                <p class="pds-footer__info-row pds-typo-caption-md-medium">
                    문의 시 '비즈니스회원'이라고 말씀주시면 더욱 원활한 상담이
                    가능합니다.
                </p>
            </div>
        </div>
        <p class="pds-footer__copyright pds-typo-caption-sm-medium">
            (주)여기어때컴퍼니 | Copyright © GC COMPANY Corp. All rights
            reserved.
        </p>
    </footer>
</template>

<script setup lang="ts">
import LogoSvg from '@/assets/image/logo.svg';

const termsUrl = import.meta.env.VITE_APP_YEOGI_WEB_TERMS_URL;
</script>

<style scoped lang="scss">
@use '@pds/style/variables/variables' as pds;

.pds-footer {
    display: flex;
    flex-direction: column;
    gap: pds.$pds-spacing-8;
    padding-top: 24px;
    padding-bottom: 88px;
    background-color: pds.$pds-color-alias-background-primary;

    &__content {
        display: flex;
        flex-direction: column;
        gap: pds.$pds-spacing-16;
    }

    &__logo {
        padding-bottom: pds.$pds-spacing-2;
    }

    &__links {
        display: flex;
        align-items: center;
        gap: pds.$pds-spacing-8;
    }

    &__link {
        color: pds.$pds-color-alias-foreground-tertiary;
        text-decoration: none;

        &--strong {
            color: pds.$pds-color-alias-foreground-primary;
        }

        &:hover {
            text-decoration: underline;
        }
    }

    &__separator {
        width: pds.$pds-spacing-1;
        height: pds.$pds-spacing-8;
        background-color: pds.$pds-color-alias-border-primary;
    }

    &__info {
        display: flex;
        flex-direction: column;
        gap: pds.$pds-spacing-4;
    }

    &__info-row {
        display: flex;
        gap: pds.$pds-spacing-4;
        margin: 0;
        color: pds.$pds-color-alias-foreground-muted;
    }

    &__info-label {
        color: pds.$pds-color-alias-foreground-muted;
    }

    &__copyright {
        margin: 0;
        color: pds.$pds-color-alias-foreground-muted;
    }
}
</style>
